import React, { Component } from 'react'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { ActionArrow, KolloscheK } from './icons'
import Subscribe from '../components/subscribe'

class SignOff extends Component {

  state = {
    subscribe: false,
  }

  render() {

    let { image, title, content, buttons, linkedToSubscribeForm } = this.props
    let { subscribe } = this.state

    return (
      <>
        <section className='sign-off'>
          <img className='sign-off__bg' loading='lazy' src={image?.sourceUrl} alt={title} />
          <div className='sign-off__inner'>
            <div className='sign-off__icon'>
              <KolloscheK color='#FFFFFF' />
            </div>
            <div className='sign-off__title'>
              <h4>{ title }</h4>
            </div>
            <div className='sign-off__content'>
              <div className='sign-off__text' dangerouslySetInnerHTML={{ __html: content }} />
              { buttons && 
                <div className='sign-off__buttons'>
                  {buttons.map((el, i) => {
                    if ( el.subscribe ) {
                      return (
                        <button type='button' className='sign-off__button' key={i} onClick={() => this.setState({ subscribe: true })}>
                          <span>{ el.text }</span>
                          <ActionArrow color='#FFFFFF'/>
                        </button>
                      )
                    } else {
                      return (
                        <Link to={el.link} className='sign-off__button' key={i}>
                          <span>{ el.text }</span>
                          <ActionArrow color='#FFFFFF'/>
                        </Link>
                      )
                    }
                  })}
                </div>
              }
            </div>
          </div>
        </section>
        { linkedToSubscribeForm && subscribe &&
          <div className='sign-off__subscribe'>
            <Subscribe />
          </div>
        }
      </>
    )
  }
}

export default SignOff
